import { createFileRoute } from "@tanstack/react-router";
import ConversingTogether from "@/components/Exercises/Conversing-Together/ConversingTogether";

export const Route = createFileRoute(
  "/(content)/adults/exercises/(shared)/conversing-together/exercise"
)({
  component: RouteComponent,
  head: () => ({
    meta: [
      {
        title: "An Exercise Through Conversing Together - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "conversingTogether.title",
    navbar: {
      showTitle: true,
    },
  }),
});

function RouteComponent() {
  return <ConversingTogether />;
}
